import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ImpersonationHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("impersonation");

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    localStorage.removeItem("jwtToken");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("refreshToken");
    localStorage.setItem("isImpersonating", "true");

    localStorage.setItem("jwtToken", token);

    window.history.replaceState({}, document.title, "/");
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
}
